import React from 'react';
import { env } from '../utils/env';

export default function Test() {
  return <div>{JSON.stringify(env)}</div>;
}
